import { Alert } from "../../ui/shadcn/alert";
import type { ReportScope } from "../model/types";

interface ValidationAlertsProps {
  scope: ReportScope;
  /** Quantas Marcações ainda faltam escolher para o escopo atual. */
  missingMarkings: number;
  error: string | null;
  onClearError: () => void;
  isGenerating: boolean;
}

export function ValidationAlerts({
  scope,
  missingMarkings,
  error,
  onClearError,
  isGenerating,
}: ValidationAlertsProps) {
  if (isGenerating) return null;

  return (
    <>
      {missingMarkings > 0 && (
        <Alert variant="info">
          ℹ️{" "}
          {scope === "comparativo"
            ? `Escolha ${missingMarkings === 2 ? "duas Marcações" : "mais uma Marcação"} para comparar.`
            : "Escolha uma Marcação abaixo ou gere o relatório de Pernambuco inteiro."}
        </Alert>
      )}

      {error && (
        <Alert variant="error" onClose={onClearError}>
          {error}
        </Alert>
      )}
    </>
  );
}
